/* eslint-disable linebreak-style */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/jsx-filename-extension */
import React, { Component } from "react";

import Header1 from "parts/Header1";
import HeroPortfolio1 from "parts/HeroPortfolio1";
import Discuss1 from "parts/Discuss1";
import Footer1 from "parts/Footer1";
import AllPortfolio1 from "parts/AllPortfolio1";

import { Portfolios } from "json/landingPageData1";

export default class ProjectPage1 extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <>
        <Header1 />
        <HeroPortfolio1 />
        <AllPortfolio1 data={Portfolios} />
        <Discuss1 />
        <Footer1 />
      </>
    );
  }
}
